export const I18N_NAMESPACES = ['common', 'portal'] as const;
export type I18nextNamespace = typeof I18N_NAMESPACES[number];

export type I18NextLanguage = 'en' | 'nl' | 'pt';
export const I18N_SUPPORTED_LANGUAGES: { key: I18NextLanguage; label: string }[] = [
  { key: 'en', label: 'English' },
  { key: 'nl', label: 'Nederlands' },
  { key: 'pt', label: 'Portuguese' },
];
